import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute(
  '/_secured/company-profile/users-management/user/',
)({
  validateSearch: z.object({
    search: z.string().optional(),
  }),
});
